/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Creator_Filter_AllInputs */

const vi_order_creator_filter_all = /** @type {(inputs: Order_Creator_Filter_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mọi người tạo`)
};

/**

* @param {Order_Creator_Filter_AllInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_creator_filter_all = /** @type {((inputs?: Order_Creator_Filter_AllInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Creator_Filter_AllInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_creator_filter_all(inputs)
});